import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../redux/auth";
import { statisticsSlice } from "../app/modules/Analytic/redux/analyticSlice";
import { accountsSlice } from "app/modules/Account/redux/accountSlice";
import { sessionSlice } from "app/modules/Session/redux/sessionSlice";
import { userSlice } from "app/modules/User/redux/userSlice";
import { applicationSlice } from "app/modules/Application/redux/applicationSlice";
import { templateSlice } from "app/modules/Template/stores/templateSlice";
import { vcSlice } from "app/modules/Vc/redux/vcSlice";
import { blockSlice } from "app/modules/WorkflowBlock/redux/blockSlice";
import {  slice as storeAppSlice } from "app/modules/StoreApp/redux/slice";
import { slice as productUsageSlice } from "app/modules/CustomerSuccess/ProductUsage/store/slice";
import { slice as customerUsageSlice } from "app/modules/CustomerSuccess/CustomerUsage/store/slice";
import { slice as overviewSlice } from "app/modules/CustomerSuccess/Overview/store/slice";
import { slice as aiLogSlice } from "app/modules/IntegrationAi/AiLog/store/slice";
export const rootReducer = combineReducers({
  auth: auth.reducer,
  accounts: accountsSlice.reducer,
  session: sessionSlice.reducer,
  user: userSlice.reducer,

  statistics: statisticsSlice.reducer,
  application: applicationSlice.reducer,
  template: templateSlice.reducer,
  vc: vcSlice.reducer,
  block: blockSlice.reducer,
  storeApp: storeAppSlice.reducer,
  customerSuccessProductUsage: productUsageSlice.reducer,
  customerSuccessCustomerUsage: customerUsageSlice.reducer,
  customerSuccessOverview: overviewSlice.reducer,
  integrationAiLog: aiLogSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
